import { defineAsyncComponent } from "vue";

export const defaultStep = "cart";
export const DOMAIN_PURCHASE_CACHE_KEY = "domain-purchase-cache-key";
export const pages = {
  cart: defineAsyncComponent(() =>
    import("@/pages/ExternalPages/DomainReg/ExternalDomainRegCart.vue")
  ),
  summary: defineAsyncComponent(() =>
    import("@/pages/ExternalPages/DomainReg/ExternalDomainRegSummary.vue")
  ),
};
